import { observer } from "mobx-react-lite";
import { Text, VStack } from "@chakra-ui/react";
import TableControl from "../components/table_control";

const AccessControlPage = observer(() => {
  return (
    <VStack width={"100%"} align={"flex-start"}>
      <Text
        marginTop={"20px"}
        color={"myColor.brightBlue"}
        fontWeight={"600"}
        fontSize={"24px"}
        marginLeft={"100px"}
      >
        Права доступа
      </Text>
      <Text color={"myColor.white"} marginLeft={"100px"}>
        Страница для редактирования доступов
      </Text>

      <VStack
        gap={0}
        padding={"0 20px"}
        marginTop={"20px"}
        align={"flex-start"}
      >
        <TableControl />
      </VStack>
    </VStack>
  );
});

export default AccessControlPage;
